module.exports = __webpack_public_path__ + "static/argus-9cc5ef7a77a6b33642f19eeeb7e50ae8.png";